import { config } from '../../config';

const initialState =
{
	name                          : '',
	// new/connecting/connected/disconnected/closed,
	state                         : 'new',
	locked                        : false,
	inLobby                       : false,
	signInRequired                : false,
	overRoomLimit                 : false,
	// access code to the room if locked and joinByAccessCode == true
	accessCode                    : '',
	// if true: accessCode is a possibility to open the room
	joinByAccessCode              : true,
	activeSpeakerId               : null,
	activeScreenId          				  : null,
	wbData                						  : null,
	allScreens             					  : [],
	torrentSupport                : false,
	showSettings                  : false,
	fullScreenConsumer            : null, // ConsumerID
	windowConsumer                : null, // ConsumerID
	toolbarsVisible               : true,
	mode                          : config?.defaultLayout,
	selectedPeers                 : [],
	spotlights                    : [],
	pagePeers                     : [],
	rolesManagerPeer              : null, // peerId
	settingsOpen                  : false,
	extraVideoOpen                : false,
	hideSelfView                  : false,
	rolesManagerOpen              : false,
	helpOpen                      : false,
	aboutOpen                     : false,
	leaveOpen                     : false,
	currentSettingsTab            : 'media', // media, appearance, advanced
	lockDialogOpen                : false,
	joined                        : false,
	muteAllInProgress             : false,
	lobbyPeersPromotionInProgress : false,
	stopAllVideoInProgress        : false,
	closeMeetingInProgress        : false,
	clearChatInProgress           : false,
	clearFileSharingInProgress    : false,
	roomPermissions               : null,
	userRoles                     : null,
	allowWhenRoleMissing          : null,
	isTelepresense            		  : false,
	telePresenseMenu           	  : false,
	autoJoin                  		  : false,
	tpPeers                	  		  : [],
	breakoutRooms                 : [],
	breakoutMainRooms             : [],
	breakedRooms                  : [],
	breakoutPeers                 : [],
	breakedPeers                  : [],
	recordMode                    : false,
	streamingOn                  	: true,
	streamingLiveOn              	: false,
	streamingConsentStatus        : false,
	broadcastUserStatus           : false,
	backgroundOpen                : false,
	templateStreamOn        			   : false,
	backgroundDialogOpen      		  : false,
	templateLeaveOpen        			  : false,
	templateLeaveDialog           : true,
	moderatorCloseMeeting     		  : false,
	recordingLicense        			   : false,
	broadcastDialogOpen       				: false,
	streamingLicense             	: false,
	cloudRecordingLicense        	: false,
	cloudRecordingStatus         	: false,
	cloudRecordingConsentStatus 		: false,
	transcriptionConsentStatus    : false,
	cloudRecordingLiveStatus      : false,
	ignoreMasking                 : null,
	emoji                         : false,
	emojiSelected                 : '',
	isInPipMode                   : false,
	hostShareDialogOpen           : false,
	shareRequestdata              : [],
	ignoreShareRequestPopup       : false,
	openShareRequest              : false,
	mDeviceType                   : '',
	activePeerId                  : '',
	breakoutPopup                 : '',
	createRoomsDataNew            : {},
	breakoutRoomsNewList          : [],
	breakoutRoomPeers             : [],
	breakoutRoomHost              : [],
	isAudioAccessble              : true,
	isVideoAccessble              : true,
	virtualBg                     : '',
	isChangeLanguageDropdown      : false,
	liveStreamOpen                : false,
	virtualBgEffect               : '',
	s3VirtualBGImages            	: [],
	youtubeStreamData             : {},
	facebookStreamData            : {},
	joinDailogStreams             : null,
	webinarPeers                  : [],
	meScreenShareHide             : false,
	youtubeStreamStatus           : false,
	facebookStreamStatus          : false,
	permissionReloadPopUp         : false,
	isBreakoutRoomStart           : false,
	endBreakoutSession            : '',
	breakoutJoin                  : false,
	isBreakoutRoomJoin            : false,
	totalPages                    : 0,
	uploadDocument                : null,
	page                          : 1,
	zoom                          : 'Initial',
	fullscreenMode                : false,
	isShareOpen                   : false,
	videoData                     : null,
	scrollDiff                    : null,
	isPip                         : false,
	pipActiveSpeaker              : null,
	meetDetails                   : null,
	webinarStreamOn               : false,
	shareLink                     : null,
	sharingType                   : null,
	isTranscriptionStart          : false,
	viewTranscription             : false,
	isEnableCC                    : false,
	endOrLeave                    : false,
	transcriptionData             : {},
	authToken                     : '',
	userId                        : null,
	selectedFiles                 : null,
	annotationsRequestData        : [],
	annotationDialog              : false,
	isTelepresenseStart           : false,
	liveTpScreens                 : 0,
	tpScreensData                 : [],
	tpScreenPagePeers             : [],
	pollSubmittedData             : {},
	tpScreenPresentationView      : '',
	syncOrAsync                   : false,
	showScreenSharePopUp          : false,
	isScreenshareAccepted         : false,
	sipURI                        : null,
	callerURI                     : null,
	openSipIncomingreq            : false,
	dialDialOutCalls              : [],
	openSipCalling                : false,
	isSipAutoAcceptCalls          : false,
	sipcallsLimit                 : false,
	SIPConferenceUsers            : [],
	SIPConferenceUsersAction      : [],
	sipMuteAll                    : false,
	sipSpotlightPeerId            : '',
	roomToken                     : '',
	scheduleType                  : '',
	callType                      : '',
	sessionName                   : null,
	roomCreationTime              : null,
	conferenceMuteAction          : false,
	sessionExp                    : false,
	transcriptionHealth           : {
		healthy: false,
		connected: false,
		metrics: null,
		lastUpdate: null
	},
	cameraControl: false,
	cameraRequestDialog           : null,
	cameraControlId               : null,
};

const room = (state = initialState, action) =>
{
	switch (action.type)
	{
		case 'SET_ROOM_DATA':
		{
			return { ...state };
		}
		case 'SET_ROOM_NAME':
		{
			const { name } = action.payload;

			return { ...state, name };
		}

		case 'SET_ROOM_STATE':
		{
			const roomState = action.payload.state;

			if (roomState === 'connected')
				return { ...state, state: roomState };
			else
				return { ...state, state: roomState, activeSpeakerId: null };
		}

		case 'SET_ROOM_LOCKED':
		{
			return { ...state, locked: true };
		}

		case 'SET_ROOM_UNLOCKED':
		{
			return { ...state, locked: false };
		}

		case 'SET_IN_LOBBY':
		{
			const { inLobby } = action.payload;

			return { ...state, inLobby };
		}

		case 'SET_SESSION_EXP':
		{
			const { sessionExp } = action.payload;

			return { ...state, sessionExp };
		}

		case 'SET_IS_AUDIO_ACCESSBLE':
		{
			const { isAudioAccessble } = action.payload;

			return { ...state, isAudioAccessble };
		}

		case 'SET_IS_VIDEO_ACCESSBLE':
		{
			const { isVideoAccessble } = action.payload;

			return { ...state, isVideoAccessble };
		}

		case 'SET_LAYOUT_FULLSCREEN':
		{
			const { fullscreenMode } = action.payload;

			return { ...state, fullscreenMode };
		}

		case 'SET_SIGN_IN_REQUIRED':
		{
			const { signInRequired } = action.payload;

			return { ...state, signInRequired };
		}
		case 'SET_OVER_ROOM_LIMIT':
		{
			const { overRoomLimit } = action.payload;

			return { ...state, overRoomLimit };
		}
		case 'SET_ACCESS_CODE':
		{
			const { accessCode } = action.payload;

			return { ...state, accessCode };
		}
		case 'SET_ACTIVEPEERID':
		{
			const { activePeerId } = action.payload;

			return { ...state, activePeerId };
		}

		case 'SET_JOIN_BY_ACCESS_CODE':
		{
			const { joinByAccessCode } = action.payload;

			return { ...state, joinByAccessCode };
		}

		case 'SET_LOCK_DIALOG_OPEN':
		{
			const { lockDialogOpen } = action.payload;

			return { ...state, lockDialogOpen };
		}

		case 'SET_SHARE_DAILOG_OPEN':
		{
			const { hostShareDialogOpen } = action.payload;

			return { ...state, hostShareDialogOpen };
		}

		case 'SET_JOIN_DAILOG_STREAMS':
		{
			const { joinDailogStreams } = action.payload;

			return { ...state, joinDailogStreams };
		}

		case 'SET_SHARE_REQUEST_DATA':
		{
			const { shareRequestdata } = action.payload;

			return { ...state, shareRequestdata };
		}

		case 'SET_ANNOTATION_DAILOG_OPEN':
		{
			const { annotationDialog } = action.payload;

			return { ...state, annotationDialog };
		}

		case 'SET_ANNOTATIONS_REQUEST_DATA':
		{
			const { annotationsRequestData } = action.payload;

			return { ...state, annotationsRequestData };
		}

		case 'SET_SETTINGS_OPEN':
		{
			const { settingsOpen } = action.payload;

			return { ...state, settingsOpen };
		}

		case 'SET_IGNORE_SHARE_REQUEST':
		{
			const ignoreShareRequestPopup = !state.ignoreShareRequestPopup;

			return { ...state, ignoreShareRequestPopup };
		}

		case 'SET_OPEN_SHARE_REQUEST':
		{
			const { openShareRequest } = action.payload;

			return { ...state, openShareRequest };
		}

		case 'SET_EXTRA_VIDEO_OPEN':
		{
			const { extraVideoOpen } = action.payload;

			return { ...state, extraVideoOpen };
		}

		case 'SET_ROLES_MANAGER_PEER':
		{
			const { rolesManagerPeer } = action.payload;

			return { ...state, rolesManagerPeer };
		}

		case 'SET_ROLES_MANAGER_OPEN':
		{
			const { rolesManagerOpen } = action.payload;

			return { ...state, rolesManagerOpen };
		}

		case 'SET_HELP_OPEN':
		{
			const { helpOpen } = action.payload;

			return { ...state, helpOpen };
		}

		case 'SET_ABOUT_OPEN':
		{
			const { aboutOpen } = action.payload;

			return { ...state, aboutOpen };
		}

		case 'SET_TP':
		{
			const { isTelepresense, autoJoin } = action.payload;

			return { ...state, isTelepresense, autoJoin };
		}

		case 'SET_AUTOJOIN':
		{
			const { autoJoin } = action.payload;

			return { ...state, autoJoin };
		}

		case 'TP_PEERS':
		{
			const { tpPeers } = action.payload;

			return { ...state, tpPeers };
		}

		case 'SET_TP_MODE':
		{
			const { telePresenseMenu } = action.payload;

			return { ...state, telePresenseMenu };
		}

		case 'SET_LEAVE_OPEN':
		{
			const { leaveOpen } = action.payload;

			return { ...state, leaveOpen };
		}

		case 'SET_SETTINGS_TAB':
		{
			const { tab } = action.payload;

			return { ...state, currentSettingsTab: tab };
		}

		case 'SET_ROOM_ACTIVE_SPEAKER':
		{
			const { peerId } = action.payload;

			return { ...state, activeSpeakerId: peerId };
		}

		case 'SET_SCREEN_ID':
		{
			const { screenId, allScreens } = action.payload;

			return { ...state, activeScreenId: screenId, allScreens };
		}

		case 'SET_WB_DATA':
		{
			const { wbData } = action.payload;

			return { ...state, wbData };
		}

		case 'SET_ALL_SCREENS':
		{
			const { allScreens } = action.payload;

			return { ...state, allScreens: allScreens };
		}

		case 'FILE_SHARING_SUPPORTED':
		{
			const { supported } = action.payload;

			return { ...state, torrentSupport: supported };
		}

		case 'TOGGLE_JOINED':
		{
			const joined = true;

			return { ...state, joined };
		}

		case 'TOGGLE_FULLSCREEN_CONSUMER':
		{
			const { consumerId } = action.payload;
			const currentConsumer = state.fullScreenConsumer;

			return { ...state, fullScreenConsumer: currentConsumer ? null : consumerId };
		}

		case 'TOGGLE_WINDOW_CONSUMER':
		{
			const { consumerId } = action.payload;
			const currentConsumer = state.windowConsumer;

			if (currentConsumer === consumerId)
				return { ...state, windowConsumer: null };
			else
				return { ...state, windowConsumer: consumerId };
		}

		case 'SET_TOOLBARS_VISIBLE':
		{
			const { toolbarsVisible } = action.payload;

			return { ...state, toolbarsVisible };
		}

		case 'SET_ENABLE_DISABLE_CLOUD_RECORDING':
		{
			const { cloudRecordingStatus } = action.payload;

			return { ...state, cloudRecordingStatus };
		}

		case 'SET_RECORDING_CONSENT':
		{
			const { cloudRecordingConsentStatus } = action.payload;

			return { ...state, cloudRecordingConsentStatus };
		}

		case 'SET_TRANSCRIPTION_CONSENT':
		{
			const { transcriptionConsentStatus } = action.payload;

			return { ...state, transcriptionConsentStatus };
		}

		case 'SET_LIVE_CLOUD_RECORD_STATUS':
		{
			const { cloudRecordingLiveStatus } = action.payload;

			return { ...state, cloudRecordingLiveStatus };
		}

		case 'SET_DISPLAY_MODE':
			return { ...state, mode: action.payload.mode };

		case 'SET_BACKGROUND_OPEN':
			return { ...state, backgroundOpen: action.payload.backgroundOpen };

		case 'ADD_SELECTED_PEER':
		{
			const { peerId } = action.payload;

			const selectedPeers = [ ...state.selectedPeers, peerId ];

			return { ...state, selectedPeers };
		}

		// Also listen for peers leaving
		case 'REMOVE_PEER':
		case 'REMOVE_SELECTED_PEER':
		{
			const { peerId } = action.payload;

			const selectedPeers =
				state.selectedPeers.filter((peer) =>
					peer !== peerId);

			return { ...state, selectedPeers };
		}

		case 'CLEAR_SELECTED_PEERS':
		{
			return { ...state, selectedPeers: [] };
		}

		case 'SET_SPOTLIGHTS':
		{
			const { spotlights } = action.payload;

			return { ...state, spotlights };
		}

		case 'SET_PAGE_PEERS':
		{
			const { pagePeers } = action.payload;

			return { ...state, pagePeers };
		}

		case 'CLEAR_PAGE_PEERS':
		{
			return { ...state, pagePeers: [] };
		}

		case 'CLEAR_SPOTLIGHTS':
		{
			return { ...state, spotlights: [] };
		}

		case 'SET_LOBBY_PEERS_PROMOTION_IN_PROGRESS':
			return { ...state, lobbyPeersPromotionInProgress: action.payload.flag };

		case 'MUTE_ALL_IN_PROGRESS':
			return { ...state, muteAllInProgress: action.payload.flag };

		case 'STOP_ALL_VIDEO_IN_PROGRESS':
			return { ...state, stopAllVideoInProgress: action.payload.flag };

		case 'STOP_ALL_SCREEN_SHARING_IN_PROGRESS':
			return { ...state, stopAllScreenSharingInProgress: action.payload.flag };

		case 'CLOSE_MEETING_IN_PROGRESS':
			return { ...state, closeMeetingInProgress: action.payload.flag };

		case 'CLEAR_CHAT_IN_PROGRESS':
			return { ...state, clearChatInProgress: action.payload.flag };

		case 'CLEAR_FILE_SHARING_IN_PROGRESS':
			return { ...state, clearFileSharingInProgress: action.payload.flag };

		case 'SET_ROOM_PERMISSIONS':
		{
			const { roomPermissions } = action.payload;

			return { ...state, roomPermissions };
		}

		case 'SET_USER_ROLES':
		{
			const { userRoles } = action.payload;

			return { ...state, userRoles };
		}

		case 'SET_ALLOW_WHEN_ROLE_MISSING':
		{
			const { allowWhenRoleMissing } = action.payload;

			return { ...state, allowWhenRoleMissing };
		}

		case 'SET_HIDE_SELF_VIEW':
		{
			const { hideSelfView } = action.payload;

			return { ...state, hideSelfView };
		}

		case 'SET_BREAKOUT_ROOMS':
		{
			const { breakoutRooms } = action.payload;

			return { ...state, breakoutRooms };
		}

		case 'SET_BREAKOUT_MAIN_ROOMS':
		{
			const { breakoutMainRooms } = action.payload;

			return { ...state, breakoutMainRooms };
		}

		case 'SET_BREAKED_ROOMS':
		{
			const { breakedRooms } = action.payload;

			return { ...state, breakedRooms };
		}

		case 'SET_BREAKED_PEERS':
		{
			const { breakedPeers } = action.payload;

			return { ...state, breakedPeers };
		}

		case 'SET_BREAKOUT_PEERS':
		{
			const { breakoutPeers } = action.payload;

			return { ...state, breakoutPeers };
		}

		case 'SET_RECORD_MODE_ON':
		{
			const { recordMode } = action.payload;

			return { ...state, recordMode };
		}

		case 'SET_STREAMIN_STATUS':
		{
			const { streamingOn } =action.payload;

			return { ...state, streamingOn };
		}
		case 'SET_STREAMING_CONSENT_STATUS':
		{
			const { streamingConsentStatus } =action.payload;

			return { ...state, streamingConsentStatus };
		}
		case 'SET_BROADCAST_USER_STATUS':
		{
			const { broadcastUserStatus } =action.payload;

			return { ...state, broadcastUserStatus };
		}
		case 'SET_FACEBOOK_STREAM_STATUS':
		{
			const { facebookStreamStatus } =action.payload;

			return { ...state, facebookStreamStatus };
		}
		case 'SET_YOUTUBE_STREAM_STATUS':
		{
			const { youtubeStreamStatus } =action.payload;

			return { ...state, youtubeStreamStatus };
		}
		case 'SET_LIVE_STREAMING_STATUS':
		{
			const { streamingLiveOn } =action.payload;

			return { ...state, streamingLiveOn };
		}
		case 'SET_TEMPLATE_LEAVE_OPEN':
		{
			const { templateLeaveOpen } = action.payload;

			return { ...state, templateLeaveOpen };
		}
		case 'SET_BACKGROUND_DIALOG_OPEN':
		{
			const { backgroundDialogOpen } = action.payload;

			return { ...state, backgroundDialogOpen };
		}
		case 'SET_CLOSE_MEETING_OPEN':
		{
			const { moderatorCloseMeeting } = action.payload;

			return { ...state, moderatorCloseMeeting };
		}

		case 'SET_TEMPLATE_STREAM_STATUS':
		{
			const { templateStreamOn } = action.payload;

			return { ...state, templateStreamOn };
		}
		case 'SET_RECORDING_LICENSE':
		{
			const { recordingLicense } = action.payload;

			return { ...state, recordingLicense };
		}
		case 'SET_STREAMING_LICENSE':
		{
			const { streamingLicense } = action.payload;

			return { ...state, streamingLicense };
		}
		case 'SET_CLOUD_RECORDING_LICENSE':
		{
			const { cloudRecordingLicense } = action.payload;

			return { ...state, cloudRecordingLicense };
		}
		case 'SET_BROADCAST_DIALOG_OPEN':
		{
			const { broadcastDialogOpen } = action.payload;

			return { ...state, broadcastDialogOpen };
		}
		case 'SET_IGNORE_MASKING':
		{
			const { ignoreMasking } = action.payload;

			return { ...state, ignoreMasking };
		}
		case 'SET_PIP_ISINPIP':
		{
			const { isInPipMode } = action.payload;

			return { ...state, isInPipMode };
		}
		case 'SET_DEVICE_TYPE':
		{
			const { mDeviceType } = action.payload;

			return { ...state, mDeviceType };
		}
		case 'SET_BREAKOUT_POPUP':
		{
			const { breakoutPopup } = action.payload;

			return { ...state, breakoutPopup };
		}
		case 'SET_CREATE_ROOMS_NEW':
		{
			const { createRoomsDataNew } = action.payload;

			return { ...state, createRoomsDataNew };
		}
		case 'SET_BREAKOUT_ROOMS_NEW':
		{
			const { breakoutRoomsNewList } = action.payload;

			return { ...state, breakoutRoomsNewList };
		}
		case 'SET_BREAKOUT_ROOM_PEERS':
		{
			const { breakoutRoomPeers } = action.payload;

			return { ...state, breakoutRoomPeers };
		}
		case 'SET_BREAKOUT_ROOM_HOST':
		{
			const { breakoutRoomHost } = action.payload;

			return { ...state, breakoutRoomHost };
		}
		case 'SET_VIRTUAL_BG_DETAILS':
		{
			const { img, blur } = action.payload;

			return { ...state, virtualBg: img, virtualBgEffect: blur };

		}
		case 'SET_S3_VIRTUAL_BG_IMAGES':
		{
			const { s3VirtualBGImages } = action.payload;

			// eslint-disable-next-line max-len
			return { ...state, s3VirtualBGImages: [ ...state.s3VirtualBGImages, s3VirtualBGImages ] };

		}
		case 'DELETE_S3_VIRTUAL_BG_IMAGES':
		{
			const { deleteS3VirtualBGImages } = action.payload;
			// eslint-disable-next-line max-len

			const filterImages = state.s3VirtualBGImages.filter((each) =>
				each.key !== deleteS3VirtualBGImages.key
			);

			return { ...state, s3VirtualBGImages: filterImages };

			// return { ...state, s3VirtualBGImages: [ ...state.s3VirtualBGImages, s3VirtualBGImages ] };
		}

		case 'SET_LIVE_STREAM_OPEN':
		{
			const { liveStreamOpen } = action.payload;

			return { ...state, liveStreamOpen };
		}
		case 'SET_IS_DROPDOWN_LANGUAGE':
		{
			const { isChangeLanguageDropdown } = action.payload;

			return { ...state, isChangeLanguageDropdown }; }

		case 'SET_YOUTUBE_STREAM_DATA':
		{
			const { youtubeStreamData } = action.payload;

			return { ...state, youtubeStreamData };
		}
		case 'SET_FACEBOOK_STREAM_DATA':
		{
			const { facebookStreamData } = action.payload;

			return { ...state, facebookStreamData };
		}
		case 'SET_WEBINAR_PEERS':
		{
			const { webinarPeers } = action.payload;

			// eslint-disable-next-line no-console
			if (webinarPeers.length === 0)
			{
				return { ...state, webinarPeers: [] };
			}

			return { ...state, webinarPeers: [ ...state.webinarPeers, ...webinarPeers ] };

		}
		case 'DELETE_WEBINAR_PEERS':
		{
			const { id } = action.payload;

			console.log('ida', id);

			const filterPeers = state.webinarPeers.filter((each) => each.userId !== id);

			console.log('oihbniofd', filterPeers);

			return { ...state, webinarPeers: [ ...filterPeers ] };

		}
		case 'SET_ME_SCREEN_SHARE_HIDE':
		{
			const { meScreenShareHide } = action.payload;

			return { ...state, meScreenShareHide };

		}
		case 'SET_PERMISSION_RELOAD_POP_UP':
		{
			const { permissionReloadPopUp } = action.payload;

			return { ...state, permissionReloadPopUp };

		}

		case 'SET_IS_BREAKOUTROOM_START':
		{
			const { isBreakoutRoomStart } = action.payload;

			return { ...state, isBreakoutRoomStart };
		}

		case 'SET_ENDBREAKOUTROOM_SESSION':
		{
			const { endBreakoutSession } = action.payload;

			return { ...state, endBreakoutSession };
		}

		case 'SET_BREAKOUT_JOIN':
		{
			const { breakoutJoin } = action.payload;

			return { ...state, breakoutJoin };
		}

		case 'SET_ISBREAKOUTROOM_JOIN':
		{
			const { isBreakoutRoomJoin } = action.payload;

			return { ...state, isBreakoutRoomJoin };
		}

		case 'SET_TOTALPAGES':
		{
			const { totalPages } = action.payload;

			return { ...state, totalPages };
		}

		case 'SET_DOCUMENT':
		{
			const { uploadDocument } = action.payload;

			return { ...state, uploadDocument };
		}

		case 'SET_PAGE':
		{
			const { page } = action.payload;

			return { ...state, page };
		}

		case 'SET_ZOOM':
		{
			const { zoom } = action.payload;

			return { ...state, zoom };
		}

		case 'SET_SHARE_OPEN':
		{
			const { isShareOpen } = action.payload;

			return { ...state, isShareOpen };
		}

		case 'SET_VIDEO_DATA':
		{
			const { videoData } = action.payload;

			return { ...state, videoData };
		}

		case 'SET_SCROLL_VALUE':
		{
			const { scrollDiff } = action.payload;

			return { ...state, scrollDiff: scrollDiff };
		}
		case 'SET_ISPIP':
		{
			return { ...state, isPip: action.payload };
		}
		case 'SET_PIP_ACTIVESPEAKER':
		{
			// const { pipActiveSpeaker } = action.payload;

			return { ...state, pipActiveSpeaker: action.payload };
		}

		case 'SET_MEET_DATA':
		{
			const { meetDetails } = action.payload;

			return { ...state, meetDetails };
		}
		case 'WEBINAR_STREAM_ON':
		{
			const { webinarStreamOn } = action.payload;

			return { ...state, webinarStreamOn };
		}
		case 'SET_SHARE_LINK':
		{
			const { shareLink } = action.payload;

			return { ...state, shareLink };
		}
		case 'SET_SHARE_TYPE':
		{
			return { ...state, shareType: action?.payload };
		}

		case 'SET_IS_START_TRANSCRIPT':
		{
			console.log('action?.payload==', action?.payload);
			const { isTranscriptionStart } = action?.payload;

			return { ...state, isTranscriptionStart };
		}
		case 'SET_ENABLE_CC':
		{
			console.log('action?.payload==', action?.payload);
			const { isEnableCC } = action?.payload;

			return { ...state, isEnableCC };
		}
		case 'SET_ENDORLEAVE':
		{
			return { ...state, endOrLeave: action?.payload };
		}

		case 'VIEW_TRANSCIPTION':
		{
			return { ...state, viewTranscription: action?.payload };
		}

		case 'SET_AUTH_TOKEN':
		{
			return { ...state, authToken: action?.payload };
		}

		case 'SET_USERID':
		{
			return { ...state, userId: action.payload };
		}

		case 'SET_SELECTED_FILE':
		{
			return { ...state, selectedFiles: action.payload };
		}

		case 'SET_IS_SYNC_OR_ASYNC':
		{
			const { syncOrAsync } = action.payload;

			return { ...state, syncOrAsync };
		}

		case 'SET_IS_TELEPRESENSE_START':
		{
			const { isTelepresenseStart } = action.payload;

			return { ...state, isTelepresenseStart };
		}
		case 'SET_TP_SCREEN_PRESENTATIONVIEW':
		{
			const { tpScreenPresentationView } = action.payload;

			return { ...state, tpScreenPresentationView };
		}
		case 'SET_LIVE_TP_SCREENS':
		{
			const { liveTpScreens } = action.payload;

			return { ...state, liveTpScreens };
		}
		case 'SET_POLL-SUBMITTED-DATA':
		{
			const { pollSubmittedData } = action.payload;

			return { ...state, pollSubmittedData };
		}

		case 'SET_TP_SCREENS_DATA':
		{
			const { tpScreensData } = action.payload;

			return { ...state, tpScreensData };
		}

		case 'SET_PEERS_TO_SCREEN_PAGES':
		{
			const { tpScreenPagePeers } = action.payload;

			return { ...state, tpScreenPagePeers };
		}
		case 'SET_SHOW_SCREENSHARE_POPUP':
		{
			return { ...state, showScreenSharePopUp: action.payload };
		}

		case 'SET_SCREENSHARE_ACCEPTED':
		{
			return { ...state, isScreenshareAccepted: action.payload };
		}
		case 'SET_SIP_URI':
		{
			const { sipURI } = action.payload;

			return { ...state, sipURI: sipURI };
		}
		case 'SET_CALLER_URI':
		{
			const { callerURI } = action.payload;

			return { ...state, callerURI: callerURI };
		}
		case 'OPEN_SIP_INCOMING_REQ':
		{
			const { openSipIncomingreq } = action.payload;

			return { ...state, openSipIncomingreq: openSipIncomingreq };
		}
		case 'ACCEPT_REJECT_INCOMING_CALL':
		{
			const { dialDialOutCalls } = action.payload;

			return { ...state, dialDialOutCalls: [ ...state.dialDialOutCalls, dialDialOutCalls ] };
		}
		case 'UPDATE_SIP_USER_CALL_STATUS':
		{
			const { peerId } = action.payload;

			const newList = state.dialDialOutCalls.filter((each) => each.peerId !== peerId);

			return { ...state, dialDialOutCalls: [ ...newList ] };
		}
		case 'SET_SIP_CALLING_OPEN':
		{
			const { openSipCalling } = action.payload;

			return { ...state, openSipCalling: openSipCalling };
		}
		case 'SET_SIP_AUTO_ACCEPT_CALLS':
		{
			const { isSipAutoAcceptCalls } = action.payload;

			return { ...state, isSipAutoAcceptCalls: isSipAutoAcceptCalls };
		}
		case 'SET_SIP_CALLS_LIMIT':
		{
			const { sipcallsLimit } = action.payload;

			return { ...state, sipcallsLimit: sipcallsLimit };
		}
		case 'SET_SIP_CONFERENCE_USERS':
		{
			const { SIPConferenceUsers } = action.payload;

			let newSIPUsers;

			if (state?.SIPConferenceUsers?.length <= 0 || SIPConferenceUsers?.length <= 0)
			{
				// If no users are in the new SIPConferenceUsers, clear the state
				newSIPUsers = SIPConferenceUsers;

			}
			else
			{
				// console.log('SET_SIP_CONFERENCE_USERSdkask');

				// Filter out users that exist in state but not in SIPConferenceUsers
				const existingUsers = state?.SIPConferenceUsers?.filter((each) =>
				{
					return SIPConferenceUsers?.some((eachItem) => eachItem.id === each.id);
				});

				// Find new users that are not in the state yet
				const newUsers = SIPConferenceUsers.filter((each) =>
				{
					return !state.SIPConferenceUsers?.some((eachItem) => eachItem.id === each.id);
				});

				// Combine existing users and new users
				newSIPUsers = [ ...existingUsers, ...newUsers ];
			}

			return { ...state, SIPConferenceUsers: newSIPUsers };
		}
		case 'SET_SIP_CONFERENCE_USERS_MUTE_ACTIONS':
		{
			const { id, status, actionType } = action.payload;

			let users;

			if (actionType === 'kick')
			{

				users = state.SIPConferenceUsers.filter((each) => each.id !== id);

			}
			else if (actionType === 'audio')
			{

				users = state.SIPConferenceUsers.map((each) =>
				{

					if (each?.id === id) return { ...each, audio: status };
					else return each;
				});
			}
			else if (actionType === 'video')
			{

				users = state.SIPConferenceUsers.map((each) =>
				{

					if (each?.id === id) return { ...each, video: status };
					else return each;
				});
			}

			return { ...state, SIPConferenceUsers: users };
		}
		case 'HANDLE_SIP_MUTE_ALL':
		{
			const { sipMuteAll } = action.payload;

			const users = state.SIPConferenceUsers.map((e) =>
			{
				e.audio = sipMuteAll ? 'true' : 'false';

				return e;
			});

			return { ...state, sipMuteAll: sipMuteAll, SIPConferenceUsers: users };
		}
		case 'HANDLE_SIP_SPOTLIGHTS':
		{
			const { sipSpotlightPeerId } = action.payload;

			return { ...state, sipSpotlightPeerId: sipSpotlightPeerId };
		}
		case 'SET_ROOM_TOKEN':
		{
			return { ...state, roomToken: action.payload };
		}
		case 'SET_SCHEDULE_TYPE':
		{
			return { ...state, scheduleType: action.payload };
		}
		case 'SET_CALL_TYPE':
		{
			return { ...state, callType: action.payload };
		}
		case 'SET_SESSION_NAME':
		{
			return { ...state, sessionName: action.payload };
		}
		case 'SET_ROOM_CREATION_TIME':
		{
			return { ...state, roomCreationTime: action.payload };
		}
		case 'SET_CONFERENCE_MUTE_ACTION':
		{
			return { ...state, conferenceMuteAction: action.payload };
		}
		case 'SET_TRANSCRIPTION_HEALTH':
		{
			return { ...state, transcriptionHealth: action.payload };
		}
		case 'SET_CAMERA_CONTROL':
		{
			return { ...state, cameraControl: action.payload };
		}
		case 'SET_CAMERA_CONTROL_ID':
		{
			return { ...state, cameraControlId: action.payload };
		}
		case 'SET_CAMERA_REQUEST_DIALOG':
		{
			return { ...state, cameraRequestDialog: action.payload };
		}
		default:
			return state;
	}
};

export default room;
